/**
 * Product Swiper – Alpine.js integration
 * Adds Swiper state and methods to Product component
 */
(function () {
  'use strict';

  const PRODUCT_ROOT = '[data-product-root]';

  function patchProduct(root, attempts = 0) {
    const maxAttempts = 50;
    const data = root._x_dataStack?.[0];

    if (!data) {
      if (attempts < maxAttempts) setTimeout(() => patchProduct(root, attempts + 1), 100);
      return;
    }

    if (data._swiperPatched) return;
    data._swiperPatched = true;

    data.swiperIsReady = false;
    data.swiperIndex = 0;
    data.slideCount = 0;

    data.goToPrevSlide = function () {
      const swiper = this.$root?.querySelector('.product-swiper')?.swiperInstance;
      if (swiper) swiper.slidePrev();
    };

    data.goToNextSlide = function () {
      const swiper = this.$root?.querySelector('.product-swiper')?.swiperInstance;
      if (swiper) swiper.slideNext();
    };

    data.goToSlide = function (indexOrEl) {
      const swiperEl = this.$root?.querySelector('.product-swiper');
      const swiper = swiperEl?.swiperInstance;
      if (!swiper) return;

      let index;
      if (typeof indexOrEl === 'number') {
        index = indexOrEl;
      } else if (indexOrEl?.nodeType === 1) {
        const slide = indexOrEl.closest('.swiper-slide');
        index = slide ? parseInt(slide.dataset.index, 10) : NaN;
      } else {
        index = NaN;
      }
      if (!isNaN(index)) swiper.slideTo(index);
    };

    data.initSwiperIntegration = function () {
      if (window.ProductSwiper?.init) window.ProductSwiper.init();
    };
  }

  function scanAndPatch() {
    document.querySelectorAll(PRODUCT_ROOT).forEach(patchProduct);
  }

  const observer = new MutationObserver(() => scanAndPatch());
  observer.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanAndPatch);
  } else {
    scanAndPatch();
  }
})();
